import React from "react";
import Modal from "react-modal";
import { IImovelFocus } from "../../../../Pages/Cartorio_Pages/App_Pages/ImovelFocus";
import theme from "../../../../Styles/theme";
import { isRural } from "../../../../Utils/isRural";
import { AddImovelForm } from "../../../AddImovelForm";
import { ModalDivX } from "../../../ModalDivX";
import { Container } from "./styles";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  imovel: IImovelFocus;
  handleSetImovel(im: IImovelFocus): void;
}

export function ModalEditImovel({
  imovel,
  handleSetImovel,
  onClose,
  open,
}: Props) {
  return (
    <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
      <ModalDivX execute={onClose} />
      <Container>
        <AddImovelForm
          handleClose={onClose}
          rural={isRural() ? true : false}
          imovel={imovel}
          handleSetImovel={handleSetImovel}
        />
      </Container>
    </Modal>
  );
}
